export default "__VITE_ASSET___o7PIoR5__"